<template>
  <div class="row mt-3 d-flex align-items-center">
    <div class="pl-0 col-lg-6 col-xs-12">
      <VueSuggestion
        :itemsArray="languages"
        v-model="language.name"
        :focusOut="languagePresent"
        :whenSelected="(item) => (language.name = item.name)"
        placeholder="IDIOMA"
      />
    </div>
    <div class="col-lg-4 col-xs-12">
      <select
        class="form-control"
        v-model="language.level"
      >
        <option
          v-for="level in this.levels"
          :key="level.value"
          :value="level.value"
        >
          {{ level.text }}
        </option>
      </select>
    </div>
    <div class="col-lg-2 col-xs-12 d-flex justify-content-between">
      <button
        class="btn-add-items-tb bg-purple color-white right"
        @click="sendLanguage"
      >
        <i class="fas fa-check"></i>
      </button>
      <button
        class="ml-1 btn-add-items-tb bg-purple color-white right"
        style="background-color: red"
        @click="cancelLanguage()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "components/VueSuggestion.vue";
import languages from "../../../../../../public/languages.json";

export default {
  props: ["candidate_id", "url_custom"],
  mounted() {
    console.log(this.candidate_id);
    this.url = `/recruiters/talent_banks/${this.candidate_id}/candidate/languages`;
    if (this.url_custom) {
      this.url = this.url_custom;
    }
  },
  components: { VueSuggestion },
  data: () => ({
    levels: [
      { text: "Não informado", value: 0 },
      { text: "Básico", value: 1 },
      { text: "Intermediário", value: 2 },
      { text: "Avançado", value: 3 },
      { text: "Fluente", value: 4 },
      { text: "Nativo", value: 5 },
    ],
    url: "",
    languages,
    language: {
      name: "",
      level: 0,
    },
  }),
  methods: {
    cancelLanguage() {
      eventBus.$emit("closeFormTb");
    },
    languagePresent(notifyInvalidness = false) {
      for (let item of languages) {
        let language = item.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
        let name = this.language.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
        if (language === name) {
          this.language.name = item.name;
          return true;
        }
      }

      if (notifyInvalidness === true) this.$toast.error("Idioma inválido");
      return false;
    },
    sendLanguage() {
      if (this.language.name.length === 0) {
        this.$toast.error("Por favor informe um idioma.");
        return;
      }
      if (!this.languagePresent(true)) return;

      axios
        .post(this.url, {
          language: {
            name: this.language.name,
            level: this.language.level,
            candidate_id: this.candidate_id,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success("Idioma adicionado com sucesso!");
            eventBus.$emit("getLanguages");
            eventBus.$emit("closeFormTb");

            return;
          }

          this.$toast.error("Não foi possivel adicionar este idioma.");
        });
    },
  },
};
</script>
